import { useMutation } from "@apollo/client";
import {
  Button,
  Grid,
  ScrollArea,
  Select,
  Switch,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { UPDATE_LOAN_PROVIDER_STAFF } from "apollo/mutuations";
import { useEffect } from "react";

const StaffEditModal = ({ editData, setOpenedEdit }) => {
  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      role: "",
      is_active: true,
    },
    validate: {
      name: (value) => (!value ? "Name is required" : null),
      email: (value) =>
        !value
          ? "Email is required"
          : !/^\S+@\S+$/.test(value)
            ? "Invalid email"
            : null,
      phone: (value) => (!value ? "Phone is required" : null),
      role: (value) => (!value ? "Role is required" : null),
    },
  });

  useEffect(() => {
    if (editData) {
      form.setValues({
        name: editData.user?.name || "",
        email: editData.user?.email || "",
        phone: editData.user?.phone || "",
        role: editData.role || "",
        is_active: editData.is_active || false,
      });
    }
  }, [editData]);

  const [updateStaff, { loading }] = useMutation(UPDATE_LOAN_PROVIDER_STAFF, {
    onCompleted: () => {
      showNotification({
        title: "Success",
        message: "Staff member updated successfully",
        color: "green",
      });
      setOpenedEdit(false);
    },
    onError: (error) => {
      showNotification({
        title: "Error",
        message: error.message || "Failed to update staff member",
        color: "red",
      });
    },
  });

  const handleSubmit = (values) => {
    updateStaff({
      variables: {
        id: editData.id,
        ...values,
      },
    });
  };

  return (
    <div>
      <div
        style={{
          fontSize: "18px",
          fontWeight: 600,
          marginBottom: "10px",
          marginTop: "30px",
        }}
      >
        Edit Staff Member
      </div>

      <ScrollArea style={{ height: "75vh" }} offsetScrollbars>
        <form onSubmit={form.onSubmit(handleSubmit)}>
          <Grid>
            <Grid.Col span={12}>
              <TextInput
                required
                label="Full Name"
                placeholder="Enter full name"
                {...form.getInputProps("name")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <TextInput
                required
                label="Email"
                placeholder="Enter email address"
                type="email"
                {...form.getInputProps("email")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <TextInput
                required
                label="Phone Number"
                placeholder="0911234567"
                {...form.getInputProps("phone")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <Select
                required
                label="Role"
                placeholder="Select role"
                data={[
                  { value: "MAKER", label: "Maker" },
                  { value: "CHECKER", label: "Checker" },
                  { value: "APPROVER", label: "Approver" },
                ]}
                {...form.getInputProps("role")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <Switch
                label="Active Status"
                checked={form.values.is_active}
                onChange={(event) =>
                  form.setFieldValue("is_active", event.currentTarget.checked)
                }
                color="green"
                size="md"
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <Button
                type="submit"
                loading={loading}
                fullWidth
                style={{ backgroundColor: "#FF6A00", marginTop: "10px" }}
              >
                Update Staff Member
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </ScrollArea>
    </div>
  );
};

export default StaffEditModal;
